import { render } from "./BasicLayout.vue?vue&type=template&id=592d27e4&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"

import "./BasicLayout.vue?vue&type=style&index=0&id=592d27e4&lang=less&scoped=true"
import "./BasicLayout.vue?vue&type=style&index=1&id=592d27e4&lang=css"

import exportComponent from "/Volumes/my/猫嗅笔记相关项目/猫嗅笔记管理后台/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592d27e4"]])

export default __exports__